import { render, staticRenderFns } from "./AssignOptionalModules.vue?vue&type=template&id=acd1c3c6&scoped=true"
import script from "./AssignOptionalModules.vue?vue&type=script&lang=js"
export * from "./AssignOptionalModules.vue?vue&type=script&lang=js"
import style0 from "./AssignOptionalModules.vue?vue&type=style&index=0&id=acd1c3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd1c3c6",
  null
  
)

export default component.exports